export const messages = {
  kidminHeaderTitle: {
    id: "auth-screen.kidmin.header-title",
    defaultMessage: "Welcome!",
  },
  kidminHeaderDescription: {
    id: "auth-screen.kidmin.header-description",
    defaultMessage: "Two Brands. One Account.",
  },
  kidminHeaderSubtitle: {
    id: "auth-screen.kidmin.header-subtitle",
    defaultMessage:
      "Use your Bible Engagement Project login to sign in to KidminRoadmap.",
  },
};
